import React from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls } from '@react-three/drei';
import { useLoader } from '@react-three/fiber';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader';

function ThreeDViewer({ objPath }) {
  const obj = useLoader(OBJLoader, objPath);

  return (
    <Canvas style={{ height: 'auto', width: '100%' }}>
      <ambientLight intensity={0.1} />
      <directionalLight position={[0, 0, 5]} />
      <primitive object={obj} position={[-3.5, -3, -2]} />
      <OrbitControls />
    </Canvas>
  );
}

export default ThreeDViewer;
